<template>
    <FormSection title="Tags" type="his-section" :full-height="false" :application-id="Number(application)">
        <template v-slot:content>
            <div class="form-group col-12 px-3 mt-2">
                <label for="patient-tags">
                    Tags
                    <a
                        tabindex="0"
                        href="javascript:void(0);"
                        role="button"
                        v-custom-popover="{ content: sanitizeMarkup(tagsTooltip) }"
                    >
                        <i class="fas fa-info-circle text-primary font-size-xs"></i>
                    </a>
                </label>
                <TagsInput
                    :data="patientTags"
                    :tags="selectedTags"
                    v-on:updateTags="updateTags"
                    placeholder="Start Typing......"
                    :open-on-focus="true"
                />
            </div>
            <div class="d-flex justify-content-end mb-4">
                <button class="btn btn-primary me-3" @click="newTagDialog">
                    New Tag
                    <i class="fa fa-arrow-right font-size-xs"></i>
                </button>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./DemographicsTags.ts"></script>
